__webpack_require__.p = "/kaungsettlwin-portfolio-react/";